import React from "react";
import { Box, CircularProgress } from "@mui/material";
import RegistrationPasswordAuth from "../../../components/RegistrationPasswordAuth";
import { useProjectedRetreatForm } from "./projected/useProjectedRetreatForm";
import { useProjectedActionBarPin } from "./projected/useProjectedActionBarPin";
import { ProjectedRetreatActionBar } from "./projected/ProjectedRetreatActionBar";
import { ProjectedRetreatFormSections } from "./projected/sections/ProjectedRetreatFormSections";
import { ProjectedRetreatModals } from "./projected/ProjectedRetreatModals";
import { projectedPageFontSx } from "./projected/projectedRetreatUi";

function ProjectedRetreatFormInner() {
  const form = useProjectedRetreatForm();
  const pin = useProjectedActionBarPin(!form.loading);

  if (form.loading) {
    return (
      <Box sx={{ py: 10, display: "flex", justifyContent: "center" }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box
      ref={pin.pageRootRef}
      sx={{
        ...projectedPageFontSx,
        maxWidth: 1180,
        mx: "auto",
        px: { xs: 1.5, sm: 2 },
        pb: 6,
      }}
    >
      <ProjectedRetreatActionBar form={form} pin={pin} />
      <ProjectedRetreatFormSections form={form} pin={pin} />
      <ProjectedRetreatModals form={form} />
    </Box>
  );
}

const ProjectedRetreatForm = () => (
  <RegistrationPasswordAuth>
    <ProjectedRetreatFormInner />
  </RegistrationPasswordAuth>
);

export default ProjectedRetreatForm;
